import { render, staticRenderFns } from "./OrgSitesTable.vue?vue&type=template&id=a5d1b4fa"
import script from "./OrgSitesTable.vue?vue&type=script&lang=js"
export * from "./OrgSitesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports